

// Collection filters + sort without page refresh (Section Rendering API).
// applyFilterUrl(url) fetches only this section, swaps its inner HTML, and updates
// the address bar via History API. Pagination is left alone (normal reload).
(function () {
    'use strict';

    // Re-init front-end widgets that use querySelectorAll once on load and therefore
    // stop working after the section HTML is swapped (range slider + brand search).
    // Accordion and swatches are delegated in the global file, so they are fine.
    function reinitWidgets(scope) {
        var root = scope || document;

        // range slider
        root.querySelectorAll('[data-range]').forEach(function (r) {
            if (r.dataset.rangeReady) return;
            r.dataset.rangeReady = '1';
            var MIN = +r.dataset.min, MAX = +r.dataset.max;
            var sMin = r.querySelector('[data-range-min]');
            var sMax = r.querySelector('[data-range-max]');
            var fFrom = r.querySelector('[data-range-from]');
            var fTo = r.querySelector('[data-range-to]');
            var fill = r.querySelector('[data-range-fill]');
            if (!sMin || !sMax || !fFrom || !fTo || !fill) return;
            function pct(v) { return ((v - MIN) / (MAX - MIN)) * 100; }
            function draw() {
                var lo = +sMin.value, hi = +sMax.value;
                fill.style.insetInlineStart = pct(lo) + '%';
                fill.style.inlineSize = (pct(hi) - pct(lo)) + '%';
            }
            function fromSliders() {
                var lo = +sMin.value, hi = +sMax.value;
                if (lo > hi) {
                    if (document.activeElement === sMin) { lo = hi; sMin.value = lo; }
                    else { hi = lo; sMax.value = hi; }
                }
                fFrom.value = lo; fTo.value = hi; draw();
            }
            function fromFields() {
                var lo = Math.max(MIN, Math.min(+fFrom.value || MIN, MAX));
                var hi = Math.max(MIN, Math.min(+fTo.value || MAX, MAX));
                if (lo > hi) lo = hi;
                sMin.value = lo; sMax.value = hi; draw();
            }
            sMin.addEventListener('input', fromSliders);
            sMax.addEventListener('input', fromSliders);
            fFrom.addEventListener('change', fromFields);
            fTo.addEventListener('change', fromFields);
            draw();
        });

        // brand search
        root.querySelectorAll('[data-fsearch]').forEach(function (group) {
            if (group.dataset.fsearchReady) return;
            group.dataset.fsearchReady = '1';
            var input = group.querySelector('[data-fsearch-input]');
            var items = Array.prototype.slice.call(group.querySelectorAll('[data-fsearch-item]'));
            var empty = group.querySelector('[data-fsearch-empty]');
            if (!input) return;
            input.addEventListener('input', function () {
                var q = input.value.trim().toLowerCase();
                var shown = 0;
                items.forEach(function (item) {
                    var match = item.textContent.trim().toLowerCase().indexOf(q) !== -1;
                    item.hidden = !match;
                    if (match) shown++;
                });
                if (empty) empty.hidden = shown !== 0;
            });
        });
        
        // show more (collection description): bound directly in the global file, so
        // the swapped-in button has no listener until it is re-bound here
        root.querySelectorAll('.lum-showmore').forEach(function (el) {
            if (el.dataset.showmoreReady) return;
            el.dataset.showmoreReady = '1';
            var btn = el.querySelector('[data-toggle]');
            if (!btn) return;
            btn.addEventListener('click', function () {
                var open = el.toggleAttribute('data-expanded');
                btn.setAttribute('aria-expanded', open ? 'true' : 'false');
            });
        });
    }

    var SECTION_SELECTOR = '[data-collection-section]';
    var sectionName = 'lum-collection';

    // Section Rendering API: same url + ?sections=<section file name> -> returns JSON
    function sectionUrl(url) {
        var u = new URL(url, window.location.origin);
        u.searchParams.set('sections', sectionName);
        return u.toString();
    }

    var busy = false;

    function applyFilterUrl(url, push) {
        if (busy) { window.location.href = url; return; }
        busy = true;

        var container = document.querySelector(SECTION_SELECTOR);
        if (container) container.setAttribute('data-loading', '');

        fetch(sectionUrl(url))
            .then(function (r) {
                if (!r.ok) throw new Error('bad response');
                return r.text();
            })
            .then(function (text) {
                // JSON: { "lum-collection": "<section html>" }
                var data = JSON.parse(text);
                var html = data[sectionName];

                var doc = new DOMParser().parseFromString(html, 'text/html');
                var fresh = doc.querySelector(SECTION_SELECTOR);
                var current = document.querySelector(SECTION_SELECTOR);
                if (fresh && current) {
                    current.innerHTML = fresh.innerHTML;
                } else if (current) {
                    current.innerHTML = html;
                }

                if (push !== false) window.history.pushState({ lumFilter: true }, '', url);

                current && current.removeAttribute('data-loading');
                busy = false;

                reinitWidgets(current);
                document.dispatchEvent(new CustomEvent('lum:collection:updated'));
            })
            .catch(function () {
                // any failure -> normal navigation so the user isn't stuck
                window.location.href = url;
            });
    }

    window.lumApplyFilterUrl = applyFilterUrl;

    // ---- delegated handlers (survive innerHTML swaps) ----

    // checkboxes: brand, availability
    document.addEventListener('change', function (e) {
        var box = e.target.closest('[data-filter-checkbox]');
        if (!box) return;
        var url = box.checked ? box.getAttribute('data-url-add') : box.getAttribute('data-url-remove');
        if (url) applyFilterUrl(url);
    });

    // color swatches
    document.addEventListener('click', function (e) {
        var sw = e.target.closest('[data-filter-swatch]');
        if (!sw) return;
        e.preventDefault();
        var active = sw.getAttribute('data-active') === '1';
        var url = active ? sw.getAttribute('data-url-remove') : sw.getAttribute('data-url-add');
        if (url) applyFilterUrl(url);
    });

    // sort tabs (<a> links)
    document.addEventListener('click', function (e) {
        var link = e.target.closest('.products-sort__option');
        if (!link) return;
        e.preventDefault();
        applyFilterUrl(link.getAttribute('href'));
    });

    // price form (Apply submits a GET form)
    document.addEventListener('submit', function (e) {
        var form = e.target.closest('form.lum-range');
        if (!form) return;
        e.preventDefault();
        var params = new URLSearchParams(new FormData(form));
        var action = form.getAttribute('action') || window.location.pathname;
        applyFilterUrl(action + '?' + params.toString());
    });

    // ---- mobile drawer: collect filters, apply once on "View Products" ----

    // mobile swatches are <label> with a hidden checkbox; clicking toggles is-selected visual
    document.addEventListener('click', function (e) {
        var label = e.target.closest('[data-mobile-filter-form] .lum-swatch');
        if (!label) return;
        // let the checkbox toggle naturally, then sync the selected class
        setTimeout(function () {
            var cb = label.querySelector('[data-swatch-check]');
            if (cb) label.classList.toggle('is-selected', cb.checked);
        }, 0);
    });

    // "View Products" applies the whole mobile form at once, then closes the drawer
    document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-mobile-apply]');
        if (!btn) return;
        e.preventDefault();
        var form = document.querySelector('[data-mobile-filter-form]');
        if (!form) return;
        var params = new URLSearchParams(new FormData(form));
        var action = form.getAttribute('action') || window.location.pathname;
        var url = params.toString() ? action + '?' + params.toString() : action;

        // close the drawer first (mirrors the front-end close)
        var drawer = document.querySelector('[data-filter-drawer]');
        if (drawer) {
            drawer.removeAttribute('data-open');
            drawer.setAttribute('aria-hidden', 'true');
        }
        document.body.style.overflow = '';

        applyFilterUrl(url);
    });

    // back / forward
    window.addEventListener('popstate', function () {
        applyFilterUrl(window.location.href, false);
    });

})();